import { createContext, useContext } from 'react';

export const AuthGateContext = createContext(null);

export const useAuthGateContext = () => useContext(AuthGateContext);

export default AuthGateContext;
